import { Form, FormField, FormItem } from '@/components/ui-kit/form';
import { useTranslation } from 'react-i18next';
import { SliderControl } from '../slider-control';
import { UseFormReturn } from 'react-hook-form';
import { AgentBehaviorSettingsForm } from '../utils';

type RiskThresholdModalProps = {
  form: UseFormReturn<AgentBehaviorSettingsForm>;
  onClose: () => void;
  isMobile?: boolean;
};

export const RiskThresholdModal = ({
  form,
  onClose,
  isMobile = false,
}: RiskThresholdModalProps) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="fixed inset-0 z-[100]" onClick={onClose} />

      <div
        className="fixed z-[101] overflow-hidden rounded-lg border bg-card shadow-lg"
        style={(() => {
          const element = document.getElementById('risk-threshold-buttons');
          if (element) {
            const rect = element.getBoundingClientRect();
            return {
              left: `${rect.left}px`,
              top: `${rect.bottom + 8}px`,
              width: `${rect.width}px`,
            };
          }
          return {};
        })()}
      >
        <div className="max-h-[70vh] overflow-y-auto">
          <div className="p-6">
            <h3 className="mb-6 text-lg font-semibold">{t('RISK_THRESHOLDS')}</h3>

            <Form {...form}>
              <div className="space-y-8">
                <FormField
                  control={form.control}
                  name="guardrail.input_risk_threshold"
                  render={({ field }) => (
                    <FormItem>
                      <SliderControl
                        label={t('INPUT_RISK_THRESHOLD')}
                        tooltipContent={t('INPUT_RISK_THRESHOLD_TOOLTIP')}
                        value={field.value || 0.7}
                        onChange={(val) => {
                          field.onChange(val);
                          form.setValue('guardrail.input_risk_threshold', val);
                        }}
                        min={0}
                        max={1}
                        step={0.01}
                        isMobile={isMobile}
                      />
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name="guardrail.output_risk_threshold"
                  render={({ field }) => (
                    <FormItem>
                      <SliderControl
                        label={t('OUTPUT_RISK_THRESHOLD')}
                        tooltipContent={t('OUTPUT_RISK_THRESHOLD_TOOLTIP')}
                        value={field.value || 0.8}
                        onChange={(val) => {
                          field.onChange(val);
                          form.setValue('guardrail.output_risk_threshold', val);
                        }}
                        min={0}
                        max={1}
                        step={0.01}
                        isMobile={isMobile}
                      />
                    </FormItem>
                  )}
                />
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};
